import { WorkItemLaneModel } from '../shared/services/lane-manager/work-item-lane.model';
import { WorkItemLaneType } from '../shared/services/lane-manager/work-item-lane-type.enum';

export const TextChatLayout: WorkItemLaneModel[] = [
  {
    id: WorkItemLaneType.CannedMessage.toString(),
    name: 'CANNED_MESSAGES',
    type: WorkItemLaneType.CannedMessage,
    width: 1,
    visible: true,
    icon: 'can-outline',
    tooltip: 'tooltips.cannedMessages'
  },
  {
    id: WorkItemLaneType.VisitorInfo.toString(),
    name: 'VISITOR_INFO',
    type: WorkItemLaneType.VisitorInfo,
    width: 1,
    visible: true,
    icon: 'info-outline',
    tooltip: 'tooltips.visitorInfo'
  },
  {
    id: WorkItemLaneType.VisitorHistory.toString(),
    name: 'VISITOR_HISTORY',
    type: WorkItemLaneType.VisitorHistory,
    width: 1,
    visible: true,
    icon: 'history-outline',
    tooltip: 'tooltips.visitorHistory'
  }
];
